import { config } from '$lib/constants/circlesV2Config';
import { SharedState } from '$utils/sharedState.svelte';

class StateCirclesRpcEndpoint extends SharedState<string> {
  public change(endpoint: string) {
    this.set(endpoint);
  }

  get current() {
    return super.current ?? config.circlesRpcUrl;
  }
}

export const stateCirclesRpcEndpoint = new StateCirclesRpcEndpoint(null);
